var render, staticRenderFns
import script from "./MTableResizableMixin.vue?vue&type=script&lang=js"
export * from "./MTableResizableMixin.vue?vue&type=script&lang=js"
import style0 from "./MTableResizableMixin.vue?vue&type=style&index=0&id=2d20da92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports